import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/58d4dc6bdda16a86e567736366152c7b.jpg)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-transparent bottom-[12.5%]"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start max-w-5xl mx-auto mt-24">
          <div className="lg:col-span-3">
            <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-orange-500 mb-8 h-[400px] w-full">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20portable%20solar%20generator%20power%20station%20with%20orange%20accents%20placed%20on%20rocky%20mountain%20terrain%20during%20golden%20hour%20sunset%20camping%20equipment%20outdoor%20adventure%20gear%20realistic%20product%20photography%20with%20simple%20natural%20background%20warm%20lighting&width=600&height=400&seq=hero-product-001&orientation=landscape"
                alt="Solar Generator in Wilderness"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="bg-black/40 backdrop-blur-md p-8 rounded-2xl border border-white/10 h-[400px] flex flex-col justify-between">
              <p className="text-lg text-gray-200 leading-relaxed">
                Honest reviews and real-world testing of <strong>solar generators</strong>, <strong>off-grid refrigeration</strong>, and <strong>camping gear</strong> that actually works when you're miles from civilization.
              </p>

              <div className="flex flex-wrap gap-4">
                <Link
                  to="/reviews"
                  className="inline-flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-black font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
                >
                  Explore Reviews
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/videos"
                  className="inline-flex items-center gap-2 bg-transparent hover:bg-white/10 text-white font-semibold px-8 py-4 rounded-full border-2 border-orange-500 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Watch Videos
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
